export class ConfirmationCancel {
  public static readonly type =
    '[Project/Manager/List] ConfirmationCancelAction';
}
